export default __webpack_public_path__ + "static/zona-v-75b504b44b7d305fec617a29ade974b6.png";